import React from 'react';
import { Popconfirm, Tooltip, Button, Icon } from 'antd';

function RenderTooltipDelete({disabled, handleOnClick}) {
  return (
    <Tooltip title="Withdraw">
      <Popconfirm
        disabled={disabled}
        placement="left"
        title="Are you sure to withdraw this invoice?"
        onConfirm={handleOnClick}
        okText="Yes"
        cancelText="No"
      >
        <Button disabled={disabled} size="small"><Icon type="close" /></Button>
      </Popconfirm>
    </Tooltip>
  );
}

export default RenderTooltipDelete;
